import React, { useCallback } from 'react';

import ButtonDropdown from '../../../common2/ButtonDropdown/ButtonDropdown';
import MenuItem from '../../../common2/DropdownButton/MenuItem';
import Locale from '../../../Translate/Locale';
import LinkIcon from '../../../../icons/link.svg';
import DORSigningLinkModal from './DORSigningLinkModal';

type DORSigningLinkButtonProps = {
  languages: Array<{ key: string; value: string }>;
  shipmentId: number;
  recipientEmail: string;
  reloadSearch: () => void;
};

function DORSigningLinkButton(props: DORSigningLinkButtonProps) {
  const { languages, shipmentId, recipientEmail, reloadSearch } = props;
  const [selectedLanguage, setSelectedLanguage] = React.useState<string | null>(null);
  const [showModal, setShowModal] = React.useState(false);

  const handleLanguageSelection = (language: string) => {
    if (language !== selectedLanguage) {
      setSelectedLanguage(language);
    }

    setShowModal(true);
  };

  const onCloseModal = useCallback(() => {
    reloadSearch();
    setShowModal(false);
  }, [reloadSearch, setShowModal]);

  return (
    <>
      <ButtonDropdown icon={LinkIcon} text="PARCEL_FINDER_DOR_SIGNING_LINK_BUTTON">
        {languages.map(({ key: language, value: label }) => (
          <MenuItem key={language} selected={false} onClick={() => handleLanguageSelection(language)}>
            <Locale>{label}</Locale>
          </MenuItem>
        ))}
      </ButtonDropdown>
      <DORSigningLinkModal
        key={`${shipmentId}-${selectedLanguage}`}
        shipmentId={shipmentId}
        defaultRecipientEmail={recipientEmail}
        show={showModal}
        onClose={onCloseModal}
        selectedLanguage={selectedLanguage}
      />
    </>
  );
}

export default React.memo(DORSigningLinkButton);
